import "@assets/css/skeleton.css";

export const ReportTableSkeleton = () => {
  const rows = 5;
  return (
    <div className="table-responsive shadow-sm border rounded">
      <table className="table table-hover align-middle mb-0">
        <thead className="table-light">
          <tr>
            <th>Nội Dung</th>
            <th>Loại</th>
            <th>Trạng thái</th>
            <th>Hành Động Đã Thực Hiện</th>
            <th>Ngày Tạo</th>
            <th>Thao Tác</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, idx) => (
            <tr key={idx}>
              <td>
                <div
                  className="shimmer"
                  style={{ height: "20px", width: "120px" }}
                />
              </td>
              <td>
                <div
                  className="shimmer"
                  style={{ height: "20px", width: "80px" }}
                />
              </td>
              <td>
                <div
                  className="shimmer"
                  style={{ height: "20px", width: "90px" }}
                />
              </td>
              <td>
                <div
                  className="shimmer"
                  style={{ height: "20px", width: "90px" }}
                />
              </td>
              <td>
                <div
                  className="shimmer"
                  style={{ height: "20px", width: "100px" }}
                />
              </td>
              <td>
                <div
                  className="shimmer"
                  style={{ height: "30px", width: "70px", borderRadius: "4px" }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const ReportDetailSkeleton = () => {
  return (
    <div className="overflow-hidden mt-2">
      <div className="container-fluid mt-2">
        <div className="d-flex gap-4" style={{ position: "relative" }}>
          {/* Cột trái - nội dung chính */}
          <div
            className="d-flex flex-column gap-4"
            style={{
              flex: 1,
              marginRight: "420px",
              minWidth: 0,
            }}
          >
            {/* Card thông tin */}
            <div className="card border-0 shadow">
              <div className="card-body">
                <div className="d-flex gap-2 mb-3 flex-wrap">
                  <div
                    className="shimmer"
                    style={{
                      height: "28px",
                      width: "100px",
                      borderRadius: "20px",
                    }}
                  />
                  <div
                    className="shimmer"
                    style={{
                      height: "28px",
                      width: "100px",
                      borderRadius: "20px",
                    }}
                  />
                </div>
                <div className="row g-3">
                  <div className="col-sm-6">
                    <div
                      className="shimmer"
                      style={{
                        height: "14px",
                        width: "60px",
                        marginBottom: "4px",
                      }}
                    />
                    <div
                      className="shimmer"
                      style={{ height: "18px", width: "150px" }}
                    />
                  </div>
                  <div className="col-sm-6">
                    <div
                      className="shimmer"
                      style={{
                        height: "14px",
                        width: "60px",
                        marginBottom: "4px",
                      }}
                    />
                    <div
                      className="shimmer"
                      style={{ height: "18px", width: "150px" }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Card nội dung mục tiêu */}
            <div className="card border-0 shadow">
              <div className="card-body">
                <div
                  className="shimmer"
                  style={{
                    height: "24px",
                    width: "160px",
                    marginBottom: "16px",
                  }}
                />
                <div className="border rounded-3 overflow-hidden">
                  <div className="row g-2 p-2 bg-body-tertiary">
                    {[1, 2, 3].map((i) => (
                      <div key={i} className="col-6 col-md-4">
                        <div
                          className="shimmer"
                          style={{
                            height: "160px",
                            width: "100%",
                            borderRadius: "8px",
                          }}
                        />
                      </div>
                    ))}
                  </div>
                  <div className="p-3">
                    <div
                      className="shimmer"
                      style={{
                        height: "18px",
                        width: "100%",
                        marginBottom: "8px",
                      }}
                    />
                    <div
                      className="shimmer"
                      style={{ height: "18px", width: "60%" }}
                    />
                    <div
                      className="shimmer"
                      style={{
                        height: "14px",
                        width: "120px",
                        marginTop: "12px",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Card chi tiết báo cáo */}
            <div className="card border-0 shadow">
              <div className="card-body">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <div
                    className="shimmer"
                    style={{ height: "24px", width: "180px" }}
                  />
                  <div
                    className="shimmer ms-auto"
                    style={{
                      height: "22px",
                      width: "40px",
                      borderRadius: "20px",
                    }}
                  />
                </div>
                {[1, 2, 3].map((i) => (
                  <div
                    key={i}
                    className="d-flex align-items-start gap-3 p-3 rounded-3"
                  >
                    <div
                      className="shimmer flex-shrink-0"
                      style={{
                        height: "40px",
                        width: "40px",
                        borderRadius: "50%",
                      }}
                    />
                    <div className="flex-grow-1">
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <div
                          className="shimmer"
                          style={{ height: "16px", width: "120px" }}
                        />
                        <div
                          className="shimmer"
                          style={{ height: "14px", width: "80px" }}
                        />
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <div
                          className="shimmer"
                          style={{
                            height: "18px",
                            width: "18px",
                            borderRadius: "50%",
                          }}
                        />
                        <div
                          className="shimmer"
                          style={{ height: "14px", width: "100px" }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Cột phải - Xử lý báo cáo fixed */}
          <div
            style={{
              position: "fixed",
              top: "165px",
              right: "20px",
              width: "380px",
              maxHeight: "calc(100vh - 120px)",
              overflowY: "auto",
              zIndex: 1000,
            }}
          >
            <div className="card border-0 shadow">
              <div className="card-body p-4">
                <div
                  className="shimmer"
                  style={{
                    height: "24px",
                    width: "140px",
                    marginBottom: "24px",
                  }}
                />

                <div className="mb-3">
                  <div
                    className="shimmer"
                    style={{
                      height: "18px",
                      width: "100px",
                      marginBottom: "6px",
                    }}
                  />
                  <div
                    className="shimmer"
                    style={{
                      height: "38px",
                      width: "100%",
                      borderRadius: "6px",
                    }}
                  />
                </div>

                <div className="mb-3">
                  <div
                    className="shimmer"
                    style={{
                      height: "18px",
                      width: "120px",
                      marginBottom: "6px",
                    }}
                  />
                  <div
                    className="shimmer"
                    style={{
                      height: "38px",
                      width: "100%",
                      borderRadius: "6px",
                    }}
                  />
                  <div
                    className="shimmer"
                    style={{ height: "14px", width: "80%", marginTop: "4px" }}
                  />
                </div>

                <div className="mb-3">
                  <div
                    className="shimmer"
                    style={{
                      height: "18px",
                      width: "100px",
                      marginBottom: "6px",
                    }}
                  />
                  <div
                    className="shimmer"
                    style={{
                      height: "80px",
                      width: "100%",
                      borderRadius: "6px",
                    }}
                  />
                  <div
                    className="shimmer"
                    style={{ height: "14px", width: "60%", marginTop: "4px" }}
                  />
                </div>

                <div className="mb-4">
                  <div className="d-flex align-items-center gap-2">
                    <div
                      className="shimmer"
                      style={{
                        height: "18px",
                        width: "18px",
                        borderRadius: "4px",
                      }}
                    />
                    <div
                      className="shimmer"
                      style={{ height: "18px", width: "160px" }}
                    />
                  </div>
                  <div
                    className="shimmer"
                    style={{ height: "14px", width: "120px", marginTop: "4px" }}
                  />
                </div>

                <div className="d-grid gap-2">
                  <div
                    className="shimmer"
                    style={{
                      height: "38px",
                      width: "100%",
                      borderRadius: "6px",
                    }}
                  />
                  <div
                    className="shimmer"
                    style={{
                      height: "38px",
                      width: "100%",
                      borderRadius: "6px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
